<template>
  <div>
    <div class="material-banner">
      <div class="material-banner-box">
        <img class="material-banner-img" src="../../../assets/pc/materialBanner.png"/>
      </div>
      <div class="material wd-1200">
        <div class="material-content">
          <p>大会文档</p>
          <div class="material-list-item" v-for="(item, index) in moduleInfo" :key="index">
            <i class="material-list-item-icon el-icon-paperclip"></i>
            <el-tooltip effect="dark" :content="decodeURIComponent(item.name)" placement="top-start">
              <a @click="downloadFile(item.url, item.name)">{{ decodeURIComponent(item.name) }}</a>
            </el-tooltip>
            <a :href="item.url" download><i class="el-icon-download"></i>下载</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dataMixins from '@/mixins/pc/data'

  export default {
    mixins: [dataMixins],
    data() {
      return {
        moduleInfo: this.getModuleData(),
      };
    },
    methods: {
      downloadFile(url, filename) {
        if (!url) return
        let link = document.createElement('a') //创建a标签
        link.style.display = 'none'  //使其隐藏
        link.href = url //赋予文件下载地址
        link.setAttribute('download', filename) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
        document.body.removeChild(link);
      }
    },
    created() {
      console.log('this.moduleInfo', this.moduleInfo);
    }
  };
</script>

<style lang="scss">
  .material-banner {
    .el-icon-download {
      font-weight: bold;
    }

    .material-banner-box {
      background-color: var(--themeColor);

      .material-banner-img {
        width: 100%;
        display: inline-block;
      }
    }

    .material {
      height: 320px;
      position: relative;

      .material-content {
        width: 1140px;
        z-index: 10;
        min-height: 320px;
        position: absolute;
        background-color: #fff;
        top: -150px;
        left: 50%;
        margin-left: -600px;
        padding: 30px 30px 10px 30px;
        box-shadow: 0 0 12px 0 rgba(0, 78, 120, 0.2);

        > p {
          margin: 0;
          padding: 0 0 20px 0;
          font-size: 16px;
          font-weight: bold;
          color: #333;
          line-height: 20px;
        }

        .material-list-item {
          width: 536px;
          height: 48px;
          line-height: 48px;
          margin: 0 60px 20px 0;
          display: inline-block;
          background: #f5f5f5;
          float: left;

          .material-list-item-icon {
            display: inline-block;
            margin: 0 4px 0 10px;
            vertical-align: 13px;
            font-size: 20px;
            overflow: hidden;
            color: var(--themeColor);
          }

          a {
            text-decoration: none;
            color: #333;
          }

          a:nth-of-type(1) {
            display: inline-block;
            width: 380px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
              cursor: pointer;
              color: var(--themeColor);
            }
          }

          a:nth-of-type(2) {
            float: right;
            width: 96px;
            height: 48px;
            line-height: 48px;
            color: #fff;
            font-weight: bold;
            text-align: center;
            cursor: pointer;
            background-color: var(--themeColor);

            i {
              vertical-align: middle;
            }
          }
        }

        .material-list-item:nth-child(odd) {
          margin-right: 0;
        }
      }
    }
  }
</style>
